module.exports = __webpack_public_path__ + "media/images/reduction_graph-da853f69cd789c05af8e5a2740175c5b.svg";